.stackedLabel {
	display: flex;
	flex-direction: column;
	align-items: start;
	gap: 5px;
	font-size: 15px;
	font-weight: 400;
	line-height: 1.6;
	color: #757575;
	text-align: start;
}

.labelHeader {
	font-size: 15px;
	font-weight: 600;
	color: black;
	text-align: start;
}

.singleLabel:global(.MuiTypography-root) {
	font-size: 15px;
	font-weight: 400;
	color: black;
	text-align: start;
}

label.formLabel {
	margin: 0;
	gap: 10px;
}

.formLabel.stacked:global(.MuiFormControlLabel-labelPlacementStart) {
	align-items: start;
}

.formLabel:global(.MuiFormControlLabel-labelPlacementTop) {
	align-items: stretch;
}

.formLabel :global(.MuiFormControlLabel-asterisk) {
	font-size: 0;
}

.formLabel :global(.MuiFormControlLabel-asterisk)::after {
	content: "";
	width: 13px;
	height: 13px;
	margin-left: 3px;
	margin-bottom: 4px;
	display: inline-block;
	background-color: #a52134;
	mask-image: url("./images/asterisk.svg");
	mask-repeat: no-repeat;
	mask-size: 100%;
}
